/* Список кампаний за период: статус, воронка, конверсия против контрольной группы. Клик — карточка кампании. */
import { MIN, OFFER_STATUS, dateTime, money, offerStatus, pct, type Offer, type Service } from "@okno/shared";
import { useActions } from "../../lib/actions";
import { useNow } from "../../lib/session";

export function minutesLeft(o: Offer, nowTs: number): number {
  return Math.max(0, Math.ceil((o.expiresAt - nowTs) / MIN));
}

export function CampaignsTable({ offers, services, days }: { offers: Offer[]; services: Service[]; days: number }) {
  const { openOffer } = useActions();
  const nowTs = useNow();
  return (
    <section className="panel">
      <div className="panel-head">
        <h2>Кампании</h2>
        <span className="muted" style={{ fontSize: 13 }}>
          {offers.length} за {days} дней
        </span>
      </div>
      <div className="panel-flush">
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Кампания</th>
                <th>Статус</th>
                <th className="right">Отправлено</th>
                <th className="right hide-sm">Открыли</th>
                <th className="right">Оплачено</th>
                <th className="right hide-sm">Конверсия</th>
                <th className="right hide-sm">Контроль</th>
              </tr>
            </thead>
            <tbody>
              {offers.map((o) => {
                const s = services.find((x) => x.id === o.serviceId);
                const key = offerStatus(o, nowTs);
                const st = OFFER_STATUS[key];
                const conv = o.funnel.delivered ? o.funnel.paid / o.funnel.delivered : 0;
                return (
                  <tr
                    key={o.id}
                    className="clickable"
                    tabIndex={0}
                    onClick={() => openOffer(o.id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        openOffer(o.id);
                      }
                    }}
                  >
                    <td>
                      <div className="cell-main">{s?.name || "Услуга удалена"}</div>
                      <div className="cell-sub">
                        {dateTime(o.createdAt)} · {money(o.price)}
                        {o.price < o.basePrice ? " вместо " + money(o.basePrice) : ""}
                        {o.bonus ? " + бонус" : ""}
                      </div>
                    </td>
                    <td>
                      <span className={"status tone-" + st.tone}>
                        {st.label}
                        {key === "active" ? " · " + minutesLeft(o, nowTs) + " мин" : ""}
                      </span>
                    </td>
                    <td className="right num">{o.funnel.sent}</td>
                    <td className="right num hide-sm">{o.funnel.opened}</td>
                    <td className="right num">
                      {o.funnel.paid} / {o.limit}
                    </td>
                    <td className="right num hide-sm">{pct(conv, 1)}</td>
                    <td className="right num hide-sm">{pct(o.controlConv || 0, 1)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
